import styled from 'styled-components';
import { Button } from 'antd';
import { FlexBoxCenter } from 'styles';

export const ModalContent = styled.div`
  .ant-form-item-control-input-content {
    input.ant-input.ant-input-lg {
      height: 50px;
      padding: 6.5px 11px;
    }
  }
  .ant-input-affix-wrapper {
    padding: 0px 11px 0px 0px;

    .ant-input-suffix img {
      width: 38px;
    }
  }
  .ant-space.ant-space-vertical {
    .ant-input-group-wrapper.ant-input-search {
      .ant-input-group {
        .ant-input-affix-wrapper {
          height: 50px;
          padding: 0px 11px;
          border-radius: 4px;
          .ant-input {
            height: 48px;
            padding: 6.5px 0px;
          }
        }
      }
    }
    .ant-select.ant-select-in-form-item {
      .ant-select-selector {
        height: 50px;

        .ant-select-selection-item {
          line-height: 50px;
        }
      }
    }
    .ant-btn {
      height: 50px;
    }
  }
  .ant-upload.ant-upload-select.ant-upload-select-picture {
    .ant-btn {
      border-radius: 4px;
    }
  }
  .ant-upload-list.ant-upload-list-picture {
    max-width: 115px;
  }
  .ant-switch-inner {
    line-height: 14px;
    font-size: 12px;
    font-weight: 600;
    margin: 2px 25px 0 8px;
  }
  .horizontal-item .ant-row.ant-form-item-row {
    flex-direction: row;
    gap: 10px;
    .ant-col.ant-form-item-control {
      width: fit-content;
      padding-bottom: 10px;
      .ant-form-item-control-input {
        min-height: fit-content;
      }
    }
  }
  .ant-space.ant-space-vertical .ant-select.ant-select-in-form-item .ant-select-selector {
    min-height: 50px;
    .ant-select-selection-search-input {
      height: 50px;
    }
  }

  // 계좌 검증 기능 막기위한 버튼 미노출
  .ant-input-group-addon {
    display: none;
  }

  ul {
    padding-left: 18px;
  }
`;

export const WhiteWrapper = styled.div`
  padding: 16px 18px;
  margin-bottom: 16px;
  background: #ffffff;
`;
export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  .ant-select.ant-select-single.ant-select-show-arrow {
    .ant-select-selector {
      width: 500px;
      height: 38px;
      .ant-select-selection-item {
        line-height: 38px;
      }
    }
  }
`;
export const TableWrapper = styled.div`
  width: 100%;

  .ant-table-content {
    .ant-table-thead > tr > th {
      height: 40px;
      /* padding: 16px; */
      padding: 0;
      background: #f2f4f6;
      border: none;
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
    }

    .ant-table-tbody > tr > td {
      height: 40px;
      padding: 10px;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
    }
  }
`;
export const DividerWrapper = styled.div`
  padding-top: 1px;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #6d7582;
`;
export const TableTitleContainer = styled(FlexBoxCenter)`
  padding-bottom: 10px;

  .collapse-header {
    font-size: 18px;
    font-weight: 600;
  }
  .collapse-desc {
    font-size: 14px;
    font-weight: 400;
    color: #6d7582;
  }
`;
export const ActionButton = styled(Button)<{ $width?: string; $height?: string }>`
  &.ant-btn.ant-btn-default:not(.ant-btn-dangerous) {
    /* width: ${({ $width }) => $width || 'fit-content'}; */
    height: ${({ $height }) => $height || '38px'};
    padding: 0px 16px;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    color: #ffffff;
    background: #46b476;
    border: none;
    border-radius: 4px;
  }
  &.ant-btn.ant-btn-default {
    padding: 0px 16px;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    border-radius: 4px;
  }
`;
